import { MenuItem, TextField } from "@mui/material"
import { FC, useState } from "react"
import { Controller } from "react-hook-form"

interface SelectWrapperProps {
  size?: "small" | "medium"
  label?: string
  options: { label: string; value: any; disabled?: boolean }[]
  margin?: "dense" | "normal" | "none"
  name: string

  value?: any
  onChange?: any

  control?: any
  rules?: any
  helperText?: any

  id?: string
  "data-testid"?: string
}

export const SelectWrapper: FC<SelectWrapperProps> = ({
  label = "",
  value = null,
  margin = "normal",
  size = "medium",
  control,
  ...props
}) => {
  const [selectedValue, setSelectedValue] = useState(value)

  const onOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    setSelectedValue(value)
    props.onChange(value)
  }

  if (control) {
    return (
      <Controller
        name={props.name}
        control={control}
        rules={props.rules}
        render={({
          field: { onChange, onBlur, value, ref },
          fieldState: { error },
        }) => (
          <TextField
            {...props}
            fullWidth
            // focused
            label={label}
            value={value || ""}
            margin={margin}
            size={size}
            variant="outlined"
            select
            onChange={(event) => {
              const value = event.target.value
              onChange(value)
            }}
            error={!!error}
            inputRef={ref}
            helperText={error ? error.message : props.helperText}
          >
            {props.options.map((item, index) => {
              return (
                <MenuItem
                  key={index}
                  value={item.value}
                  disabled={item.disabled || false}
                >
                  {item.label}
                </MenuItem>
              )
            })}
          </TextField>
        )}
      />
    )
  }

  return (
    <TextField
      {...props}
      fullWidth
      // focused
      label={label}
      value={selectedValue || ""}
      margin={margin}
      size={size}
      variant="outlined"
      select
      onChange={onOptionChange}
    >
      {props.options.map((item, index) => {
        return (
          <MenuItem key={index} value={item.value}>
            {item.label}
          </MenuItem>
        )
      })}
    </TextField>
  )
}
